import React from "react";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";

import emailIcon from "../../../theme/assets/svg/tc_cab_settings_email_icon.svg";
import passwordIcon from "../../../theme/assets/svg/tc_cab_settings_password_icon.svg";
import faIcon from "../../../theme/assets/svg/tc_cab_settings_2fa_icon.svg";
import {useDispatch, useSelector} from "react-redux";
import {setSettingsChangeEmailModalStatus, setSettingsChangePasswordModalStatus} from "../../../store/cabinet/action";


const CabinetSettingsChange = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const userData = useSelector(store => store.cabinet.userData);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC} ${Styles.perspective3dXl}`}>
                <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl} ${Styles.rotate3dRightXl}`}>
                    <div className={`${Styles.cardBox}`}>
                        <div className={`${Styles.contentBoxTitle}`}>{t('Аккаунт')}</div>
                        <div className={`${Styles.changeWrap}`}>
                            <div className={`${Styles.changeRow}`}>
                                <div className={`${Styles.changeRowInfo}`}>
                                    <div className={`${Styles.changeRowIconWrap}`}>
                                        <img src={emailIcon} alt={t('Email')}/>
                                    </div>
                                    <div className={`${Styles.changeRowPos}`}>
                                        <div className={`${Styles.changeRowPosName}`}>Email</div>
                                        <div className={`${Styles.changeRowPosValue}`}>{userData?.user?.email || ''}</div>
                                    </div>
                                </div>
                                <div className={`${Styles.changeRowBtn}`} onClick={()=>{dispatch(setSettingsChangeEmailModalStatus(true))}}>{t('Изменить')}</div>
                            </div>
                            <div className={`${Styles.changeRow}`}>
                                <div className={`${Styles.changeRowInfo}`}>
                                    <div className={`${Styles.changeRowIconWrap}`}>
                                        <img src={passwordIcon} alt={t('Пароль')}/>
                                    </div>
                                    <div className={`${Styles.changeRowPos}`}>
                                        <div className={`${Styles.changeRowPosName}`}>{t('Пароль')}</div>
                                        <div className={`${Styles.changeRowPosValue}`}>••••••••••••••••</div>
                                    </div>
                                </div>
                                <div className={`${Styles.changeRowBtn}`} onClick={()=>{dispatch(setSettingsChangePasswordModalStatus(true))}}>{t('Изменить')}</div>
                            </div>
                            <div className={`${Styles.changeRow}`}>
                                <div className={`${Styles.changeRowInfo}`}>
                                    <div className={`${Styles.changeRowIconWrap}`}>
                                        <img src={faIcon} alt={t('Двухфакторная аутентификация')}/>
                                    </div>
                                    <div className={`${Styles.changeRowPos}`}>
                                        <div className={`${Styles.changeRowPosName}`}>{t('Двухфакторная аутентификация')}</div>
                                        <div className={`${Styles.changeRowPosValue} ${userData?.user?.fa ? Styles.faA : Styles.faP}`}><span>•</span>{userData?.user?.fa ? t('Подключено') : t('Не подключено')}</div>
                                    </div>
                                </div>
                                <div className={`${Styles.changeRowBtn} ${Styles.changeRowBtnВsb}`}>{userData?.user?.fa ? t('Выключить 2FA') : t('Включить 2FA')} <span>{t('Скоро')}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetSettingsChange;